import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeleteBannerUseCaseInterface } from 'domain/usecases';

export class RemoteDeleteBanner implements DeleteBannerUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<DeleteBannerUseCaseInterface.Result>,
  ) {}

  async execute(
    params: DeleteBannerUseCaseInterface.Params,
  ): Promise<DeleteBannerUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'delete',
      url: this.url + '/' + params.id,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
